/** @module Specification/AggregateDataSheets */
define([
    "dojo/_base/declare",
    "csi",
    "csi/_base/underscore",
    "csi/table/AggregateFrom",
    "csi/xml",
    "csi/xml/Query"
], function(declare,csi,_,AggregateController,xml,Query) {

    return declare(AggregateController, {

        /**
         * @override
         *
         * When DataPackage.ForProductSource is not empty, user can select:
         * Data Sheets with empty ForProductSource
         * and
         * Data Sheets with ForProductSource equal to the DataPackage.ForProductSource
         * When DataPackage.ForProductSource is empty, user can select:
         * Any data sheet, but with an ad-hoc column filter for only empty DataSheet.ForProductSource
         */

        applyActionFilters: function(view) {
            var dataPackage = this.getParent();
            if(dataPackage.ForProductSource && dataPackage.ForProductSource != csi.EMPTY_URL) {
                /* When DataPackage.ForProductSource is not empty, user can select:
                Data Sheets with empty ForProductSource
                and
                Data Sheets with ForProductSource equal to the DataPackage.ForProductSource */
                var query = new Query();
                query.Or()
                    .RefAttr("ForProductSource", xml.OP_EQUALS, dataPackage.ForProductSource, "Child:__Parent__")
                    .RefAttr("ForProductSource", xml.OP_EQUALS, csi.EMPTY_URL, "Child:__Parent__");
                view.relRoot.addQuery(query);
            } else {
                /*
                 When DataPackage.ForProductSource is empty, user can select:
                 Any data sheet, but with an ad-hoc column filter for only empty DataSheet.ForProductSource.
                 */
                var q = _.clone(view.get("query"));
                q["Node Name:Child:__Parent__/Child:ForProductSource"] = [xml.VALUE_BLANK];
                view.set("query", q);
            }
            this.inherited(arguments);
        }
    });
});